import { ScannableCodesState } from './types'

export const initialScannableCodesState: ScannableCodesState = {
  instoreScanningEnabled: false,
  isFormDisabled: false,
  isFormSubmitting: false,
}
